import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles/index';
import Grid from 'material-ui/Grid';
import Paper from 'material-ui/Paper';
import ScanId from './ScanId';
import ScannedIdData from './ScannedIdData';
import TakePhoto from './TakePhoto';
import TakenPhotoData from './TakenPhotoData';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: '100%',
    },
    button: {
        marginLeft: unit * 2,
    },
    paper: {
        display: 'flex',
        padding: unit * 2,
        margin: unit,
    },
});

function VerifyApplicant(props) {
    return (
        <Grid
            container
            spacing={16}
            className={props.classes.gridContainer}
        >
            <Grid
                item
                xs={12}
                sm={6}
            >
                <Paper className={props.classes.paper}>
                    {!props.scannedId &&
                        <ScanId
                            setApplicantScannedId={props.setApplicantScannedId}
                        />
                    }
                    {props.scannedId &&
                        <ScannedIdData
                            setApplicantScannedId={props.setApplicantScannedId}
                            applicant={props.applicant}
                        />
                    }
                </Paper>
            </Grid>
            <Grid
                item
                xs={12}
                sm={6}
            >
                <Paper className={props.classes.paper}>
                    {!props.takenPhoto &&
                    <TakePhoto
                        setApplicantTakenPhoto={props.setApplicantTakenPhoto}
                    />
                    }
                    {props.takenPhoto &&
                    <TakenPhotoData
                        setApplicantTakenPhoto={props.setApplicantTakenPhoto}
                        photoUrl={props.photoUrl}
                    />
                    }
                </Paper>
            </Grid>
        </Grid>
    );
}

VerifyApplicant.propTypes = {
    scannedId: PropTypes.bool.isRequired,
    takenPhoto: PropTypes.bool.isRequired,
    setApplicantScannedId: PropTypes.func.isRequired,
    setApplicantTakenPhoto: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    photoUrl: PropTypes.string.isRequired,
    applicant: PropTypes.object.isRequired,
};

export default withStyles(styles)(VerifyApplicant);



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantIdVerification/components/VerifyApplicant.js